import {Button, Modal} from "react-bootstrap";
import SuccIcon from "../../../images/ModalSucc.svg";
import EcheccIcon from "../../../images/ModalEchec.svg";
import {useState} from "react";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";

const CertainModal = ({
  show,
  setShow,
  handelButton,
  title,
  message,
  buttonTitle,
  secondButtonTitle,
}) => {
  return (
    <Modal
      className="modal fade"
      show={show}
      onHide={() => {
        setShow(false);
      }}
      centered
    >
      <div className="modal-content">
        <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              setShow(false);
            }}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !p-2">
          <div className=" flex flex-col gap-2 justify-center items-center sm:!px-12 ">
            <img src={EcheccIcon} alt="ToastIcon" className="w-16 !mb-4" />

            <div className="text-[#FF0000] font-bold text-xl text-center !mb-1">
              {title}
            </div>

            <div className="text-[#19295C] text-center font-semibold text-sm ">
              {message}
            </div>

            <div className="flex gap-4 items-center w-full !mt-4 mb-3 ">
              <button
                onClick={() => {
                  setShow(false);
                }}
                type="button"
                className="!rounded-md w-1/2  bg-white  !py-3 text-[#1A64B9] !border !border-[#1A64B9] font-medium text-sm "
              >
                {secondButtonTitle ?? "Annuler"}
              </button>
              <button
                onClick={handelButton}
                type="button"
                className="!rounded-md w-1/2   !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    "
              >
                {buttonTitle ?? "Confirmer"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default CertainModal;
